<template>
    <section class="user_profile inner_pages">
        <div class="container">
            <div class="user_profile_info gray-bg padding_4x4_40">
                <div class="upload_user_logo">
                    <img src="assets/images/222x172.jpg" alt="image" />
                    <div class="upload_newlogo">
                        <input name="upload" type="file" />
                    </div>
                </div>
                <div class="dealer_info">
                    <h5>Centro de Usados | Daniel Gonzalez</h5>
                    <p>
                        Asesor de Usados - Redautos <br />
                        Calle 5 # 14 - 47 , 320 666 0716
                    </p>
                </div>
            </div>

            <div class="row">
                <div class="col-md-3 col-sm-3">
                    <div class="profile_nav">
                        <div
                            class="nav flex-column "
                            id="v-pills-tab"
                            role="tablist"
                            aria-orientation="vertical"
                        >
                            <a
                                class="nav-link active"
                                id="v-pills-miperfil-tab"
                                data-toggle="pill"
                                href="#v-pills-miperfil"
                                role="tab"
                                aria-controls="v-pills-miperfil"
                                aria-selected="true"
                                >Mi Perfil</a
                            >
                            <a
                                class="nav-link"
                                id="v-pills-inventario-tab"
                                data-toggle="pill"
                                href="#v-pills-inventario"
                                role="tab"
                                aria-controls="v-pills-inventario"
                                aria-selected="false"
                                >Mis Vehículos</a
                            >
                            <a
                                class="nav-link"
                                id="v-pills-reportar-tab"
                                data-toggle="pill"
                                href="#v-pills-reportar"
                                role="tab"
                                aria-controls="v-pills-reportar"
                                aria-selected="false"
                                >Reportar Vehículo</a
                            >
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-sm-8">
                    <div class="tab-content" id="v-pills-tabContent">
                        <div
                            class="tab-pane fade show active"
                            id="v-pills-miperfil"
                            role="tabpanel"
                            aria-labelledby="v-pills-miperfil-tab"
                        >
                            <formPerfil />
                        </div>
                        <div
                            class="tab-pane fade"
                            id="v-pills-inventario"
                            role="tabpanel"
                            aria-labelledby="v-pills-inventario-tab"
                        >
                            <misVehiculos />
                        </div>
                        <div
                            class="tab-pane fade"
                            id="v-pills-reportar"
                            role="tabpanel"
                            aria-labelledby="v-pills-reportar-tab"
                        >
                            <formReportar />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--/Profile-setting-->
</template>

<script>
import formPerfil from "./frontFormPerfil";
import misVehiculos from "./frontMisVehiculos";
import formReportar from "./frontFormReporte";
export default {
    components: {
        formPerfil,
        misVehiculos,
        formReportar
    }
};
</script>

<style lang="scss" scoped></style>
